import { Panel, Typography } from "@/components/atoms";
import { useOperator } from "@/hooks";
import { AddClientForm } from "./AddClientForm";

export const AddClientPanel = () => {
  const operator = useOperator();

  return (
    <Panel>
      <div className="block">
        <Typography variant="h3" className="leading-8">
          Sign up a New Client
        </Typography>
        <Typography className="text-neutral-dark-gray">Add a new {operator.name} client</Typography>
      </div>
      <AddClientForm />
    </Panel>
  );
};
